import type { FC } from "react";
import { toast } from "sonner";
import { usePinPortfolioRelatedMutation } from "web_myplann/Api/Portfolio/Mutations/usePinPortfolioRelatedMutation";
import { useUnpinPortfolioRelatedMutation } from "web_myplann/Api/Portfolio/Mutations/useUnpinPortfolioRelatedMutation";
import { usePortfolioRelatedOptionsQuery } from "web_myplann/Api/Portfolio/Queries/usePortfolioRelatedOptionsQuery";
import type { ClientPortfolioDetailRelatedResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { RelatedPinKind } from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/pinKind";
import { RelatedPinDrawerContent } from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/RelatedPinDrawerContent";

type Props = {
	kind: RelatedPinKind;
	open: boolean;
	onClose: () => void;
	related: ClientPortfolioDetailRelatedResponseDTO[];
	portfolioId: number;
};

export const PortfolioRelatedPinDrawer: FC<Props> = ({
	kind,
	open,
	onClose,
	related,
	portfolioId,
}) => {
	const { t } = useResource();

	const { data: options, isLoading } = usePortfolioRelatedOptionsQuery(
		portfolioId,
		open,
	);
	const { mutate: pinRelated, isPending: isPinning } =
		usePinPortfolioRelatedMutation(portfolioId);
	const { mutate: unpinRelated, isPending: isUnpinning } =
		useUnpinPortfolioRelatedMutation(portfolioId);

	return (
		<RelatedPinDrawerContent
			kind={kind}
			open={open}
			onClose={onClose}
			related={related}
			options={options}
			isLoading={open && isLoading}
			isPending={isPinning || isUnpinning}
			onPin={(request) =>
				pinRelated(request, {
					onSuccess: () => {
						toast.success(t(Resources.DataCard.relatedPinToast));
						onClose();
					},
				})
			}
			onUnpin={(relatedId) =>
				unpinRelated(relatedId, {
					onSuccess: () =>
						toast.success(t(Resources.DataCard.relatedUnpinToast)),
				})
			}
		/>
	);
};
